module.exports = __webpack_public_path__ + "ipetbooking-landing/img/home_plan.860beeed.png";